import Axios from "axios";
import { REACT_APP_API_PROVIDERS, REACT_APP_API_SIM } from '../../config'


// curl -X POST "https://test.sim.tygo.net/api/v2/Browse/1/CheckEligibility" -H  "accept: text/plain; ver=2.0" -H  "Content-Type: application/json; ver=2.0" -d "{\"name\":\"string\",\"nationality\":0,\"idNumber\":\"string\",\"idType\":0,\"contractType\":\"string\",\"customerContactNumber\":\"string\",\"lng\":\"string\",\"lat\":\"string\",\"plan_id\":\"string\",\"countryInfo\":{\"name\":\"string\",\"tcC_ID\":\"string\",\"countryCode\":\"string\",\"alpha2Code\":\"string\",\"alpha3Code\":\"string\",\"isO3166Code\":\"string\"}}"

const getIpAddress = async () => {
  try {
    const response = await Axios.get("https://api.ipify.org?format=json");
    console.log("IP Address:", response.data.ip);
    return response.data.ip;
  } catch (error) {
    console.error("Error fetching IP address:", error);
    return "";
  }
};

const checkEligibility = async (data: any, providerId: number) => {
  const user = JSON.parse(localStorage.getItem('tygo_user') || '{}');
  const { correlationId, transactionId } = generateCorrelationAndTransactionId(data.plan_id);
  const response = await Axios.post(
    REACT_APP_API_SIM + "/api/v2/Browse/" + providerId + "/CheckEligibility",
    data,
    {
      headers: {
        accept: "text/plain; ver=2.0",
        "Content-Type": "application/json; ver=2.0",
        authorization: "Bearer " + user.token,
        correlationId: correlationId,
        transactionId: transactionId,
        ...contractTypeHeader(),
      },
    }
  );
  return response.data;
}

export {
  checkEligibility,
  checkout,
  getNumbers,
  getResellerPlanId,
  otpConfirm,
  generateCheckoutId,
  checkoutConfirm,
  getOrderById,
  nafathLogin,
  checkNafathLogin,
  checkoutActivation,
  reserveNumber,
  getQuickOrderForUser,
  getMetadata,
  setContractType,
  resetCorrelationId
}

// https://test.sim.tygo.net/api/v2/Order/GetQuickOrderForUser
const getQuickOrderForUser = async () => {
  const user = JSON.parse(localStorage.getItem('tygo_user') || '{}');
  if (user) {
    const response = await Axios.get(
      REACT_APP_API_SIM + "/api/v2/Order/GetQuickOrderForUser",
      {
        headers: {
          accept: "text/plain; ver=2.0",
          "Content-Type": "application/json; ver=2.0",
          authorization: "Bearer " + user.token,
          ...contractTypeHeader(),
        },
      }
    );
    return response.data;
  }
  else {
    return null;
  }
}

// curl -X POST "https://test.sim.tygo.net/api/v2/Order/14/CheckoutConfirm" -H  "accept: text/plain; ver=2.0" -H  "Content-Type: application/json; ver=2.0" -d "{\"providerOrderId\":\"string\",\"amount\":0,\"providerCheckoutId\":\"string\",\"tygoCheckoutId\":\"string\",\"tygoTransactionId\":\"string\",\"paymentStatus\":true,\"date\":\"2025-04-13T21:08:16.590Z\",\"tygoOrderId\":\"string\",\"entityType\":\"VISA\"}"
const checkoutConfirm = async (data: any, providerId: number, plan_id?: string) => {
  const { correlationId, transactionId } = generateCorrelationAndTransactionId(plan_id ? parseInt(plan_id) : 0);
  const user = JSON.parse(localStorage.getItem('tygo_user') || '{}');
  if (user) {
    const response = await Axios.post(
      REACT_APP_API_SIM + "/api/v2/Order/" + providerId + "/CheckoutConfirm",
      data,
      {
        headers: {
          accept: "text/plain; ver=2.0",
          "Content-Type": "application/json; ver=2.0",
          authorization: "Bearer " + user.token,
          correlationId: correlationId,
          transactionId: transactionId,
          ...contractTypeHeader(),
        },
      }
    );
    return response.data;
  }
  else {
    return null;
  }
}
// curl -X GET "https://test.sim.tygo.net/api/v2/Order/14/GetOrderById?tygoOrderId=1&providerOrderId=1" -H  "accept: text/plain; ver=2.0"

const getOrderById = async (providerId: number, tygoOrderId: string, providerOrderId: string, lang?: string) => {
  const user = JSON.parse(localStorage.getItem('tygo_user') || '{}');
  if (user) {
    const response = await Axios.get(
      REACT_APP_API_SIM + "/api/v2/Order/" + providerId + "/GetOrderById?tygoOrderId=" + tygoOrderId + "&providerOrderId=" + providerOrderId,
      {
        headers: {
          accept: "text/plain; ver=2.0",
          authorization: "Bearer " + user.token,
          ...(lang ? { 'Accept-Language': lang } : {}),
          ...contractTypeHeader(),
        },
      }
    );
    return response.data;
  }
  else {
    return null;
  }
}

// curl -X POST "https://test.sim.tygo.net/api/v2/Activation/14/NafathLogin" -H  "accept: text/plain; ver=2.0" -H  "Content-Type: application/json; ver=2.0" -d "{\"nationality_id_number\":\"string\",\"service\":\"string\"}"

const nafathLogin = async (data: any, providerId: number, lang?: string) => {
  const user = JSON.parse(localStorage.getItem('tygo_user') || '{}');
  const { correlationId, transactionId } = generateCorrelationAndTransactionId(data.plan_id);
  if (user) {
    const ip = await getIpAddress();
    const response = await Axios.post(
      REACT_APP_API_SIM + "/api/v2/Activation/" + providerId + "/NafathLogin",
      data,
      {
        headers: {
          accept: "text/plain; ver=2.0",
          authorization: "Bearer " + user.token,
          "X-APP-USER-IP": ip,
          ...(lang ? { 'Accept-Language': lang } : {}),
          correlationId: correlationId,
          transactionId: transactionId,
          ...contractTypeHeader(),
        },
      }
    );
    return response.data;
  }
  else {
    return null;
  }
}

// // curl -X POST "https://test.sim.tygo.net/api/v2/Activation/14/CheckoutActivation" -H  "accept: text/plain; ver=2.0" -H  "Content-Type: application/json; ver=2.0" -d "{\"providerOrderId\":\"string\",\"tygoOrderId\":\"string\",\"iccid\":\"string\",\"iam_token\":\"string\",\"fingerindex\":0,\"fingerImage\":\"string\",\"tcn\":\"string\",\"faceImage\":\"string\"}"

// const checkoutActivation = async (data: any, providerId: number) => {
//   const user = JSON.parse(localStorage.getItem('tygo_user') || '{}');
//   if (user) {
//     const response = await Axios.post(
//       REACT_APP_API_SIM + "/api/v2/Activation/" + providerId + "/CheckoutActivation",
//       data,
//       {
//         headers: {
//           accept: "text/plain; ver=2.0",
//           authorization: "Bearer " + user.token,
//         },
//       }
//     );
//     return response.data;
//   }
//   else {
//     return null;
//   }
// }


// curl -X POST "https://test.sim.tygo.net/api/v2/Activation/14/CheckNafathLogin" -H  "accept: text/plain; ver=2.0" -H  "Content-Type: application/json; ver=2.0" -d "{\"code\":\"string\"}"

const checkNafathLogin = async (data: any, providerId: number, lang?: string) => {
  const { correlationId, transactionId } = generateCorrelationAndTransactionId(data.plan_id);
  const user = JSON.parse(localStorage.getItem('tygo_user') || '{}');

  if (user) {
    const ip = await getIpAddress();
    const response = await Axios.post(
      REACT_APP_API_SIM + "/api/v2/Activation/" + providerId + "/CheckNafathLogin",
      data,
      {
        headers: {
          accept: "text/plain; ver=2.0",
          authorization: "Bearer " + user.token,
          "X-APP-USER-IP": ip,
          ...(lang ? { 'Accept-Language': lang } : {}),
          correlationId: correlationId,
          transactionId: transactionId,
          ...contractTypeHeader(),

        },
      }
    );
    return response.data;
  }
  else {
    return null;
  }
}

// curl -X POST "https://test.sim.tygo.net/api/v2/Activation/14/CheckoutActivation" -H  "accept: text/plain; ver=2.0" -H  "Content-Type: application/json; ver=2.0" -d "{\"providerOrderId\":\"string\",\"tygoOrderId\":\"string\",\"iccid\":\"string\",\"iam_token\":\"string\",\"fingerindex\":0,\"fingerImage\":\"string\",\"tcn\":\"string\",\"faceImage\":\"string\"}"

const checkoutActivation = async (data: any, providerId: number, lang: string) => {
  const { correlationId, transactionId } = generateCorrelationAndTransactionId(data.plan_id);

  const user = JSON.parse(localStorage.getItem('tygo_user') || '{}');
  if (user) {
    const ip = await getIpAddress();
    const response = await Axios.post(
      REACT_APP_API_SIM + "/api/v2/Activation/" + providerId + "/CheckoutActivation",
      data,
      {
        headers: {
          accept: "text/plain; ver=2.0",
          authorization: "Bearer " + user.token,
          'Accept-Language': lang,
          "X-APP-USER-IP": ip,
          correlationId: correlationId,
          transactionId: transactionId,
          ...contractTypeHeader(),
        },
      }
    );
    return response.data;
  }
  else {
    return null;
  }
}
const generateCheckoutId = async (data: any, providerId: number) => {
  const user = JSON.parse(localStorage.getItem('tygo_user') || '{}');
  const { correlationId, transactionId } = generateCorrelationAndTransactionId(data.plan_id);
  if (user) {
    const response = await Axios.post(
      REACT_APP_API_SIM + "/api/v2/Order/" + providerId + "/GenerateCheckoutId",
      data,

      {
        headers: {
          accept: "text/plain; ver=2.0",
          authorization: "Bearer " + user.token,
          correlationId: correlationId,
          transactionId: transactionId,
          ...contractTypeHeader(),

        },
      }
    );
    return response.data;
  }
  else {
    return null;
  }
}


// // curl -X POST "https://test.sim.tygo.net/api/v2/Order/14/Checkout" -H  "accept: text/plain; ver=2.0" -H  "Content-Type: application/json; ver=2.0" -d "{\"nationality\":{\"id\":\"string\",\"idType\":\"string\",\"eligible\":true,\"country_id\":\"string\",\"country_name\":\"string\"},\"number\":{\"reservation_id\":\"string\",\"identifier\":\"string\"},\"customer\":{\"email\":\"string\",\"email_verified\":\"string\",\"contact_number_verified\":\"string\",\"contact_number\":\"string\",\"contact_number_encrypted\":\"string\",\"name\":\"string\",\"visitorOTPType\":\"string\",\"countryCode\":\"string\"},\"delivery\":{\"delivery_lat\":\"string\",\"delivery_lng\":\"string\",\"delivery_notes\":\"string\",\"delivery_country\":\"string\",\"delivery_address\":\"string\",\"delivery_city\":\"string\",\"delivery_district\":\"string\",\"delivery_postalcode\":\"string\"},\"plan_id\":\"string\",\"sim_type\":0,\"numberOrderType\":0,\"mnpOperator\":\"string\",\"mnpNumber\":\"string\"}"
const checkout = async (data: any, providerId: number, lang: string) => {
  const user = JSON.parse(localStorage.getItem('tygo_user') || '{}');
  // generateCorrelationAndTransactionId
  const { correlationId, transactionId } = generateCorrelationAndTransactionId(data.plan_id);
  if (user) {
    const response = await Axios.post(
      REACT_APP_API_SIM + "/api/v2/Order/" + providerId + "/Checkout",
      data,
      {
        headers: {

          accept: "text/plain; ver=2.0",
          "Content-Type": "application/json; ver=2.0",
          authorization: "Bearer " + user.token,
          'Accept-Language': lang,
          correlationId: correlationId,
          transactionId: transactionId,
          ...contractTypeHeader(),

        },
      }
    );
    return response.data;
  }
  else {
    return null;
  }
}
// curl -X GET "https://test.sim.tygo.net/api/v2/Browse/1/GetNumbers?vanityId=3&planeId=2" -H  "accept: text/plain; ver=2.0"
const getNumbers = async (vanityId: number | null, planeId: number, providerId: number) => {
  const user = JSON.parse(localStorage.getItem('tygo_user') || '{}');
  const { correlationId, transactionId } = generateCorrelationAndTransactionId(planeId);

  if (user) {
    const response = await Axios.get(
      REACT_APP_API_SIM + "/api/v2/Browse/" + providerId + "/GetNumbers?" + (vanityId !== null ? "vanityId=" + vanityId + "&" : "") + "planeId=" + planeId,
      {
        headers: {
          correlationId: correlationId,
          transactionId: transactionId,
          accept: "text/plain; ver=2.0",
          authorization: "Bearer " + user.token,
          ...contractTypeHeader(),
        },
      }
    );
    return response.data;
  }
  else {
    return null;
  }
}
// curl -X POST "https://test.sim.tygo.net/api/v2/Browse/14/ReserveNumber" -H  "accept: text/plain; ver=2.0" -H  "Content-Type: application/json; ver=2.0" -d "{\"identifier\":\"string\"}"
const reserveNumber = async (data: { identifier: string, plan_id: number }, providerId: number) => {
  const user = JSON.parse(localStorage.getItem('tygo_user') || '{}');
  const { correlationId, transactionId } = generateCorrelationAndTransactionId(data.plan_id);
  if (user) {
    const response = await Axios.post(
      REACT_APP_API_SIM + "/api/v2/Browse/" + providerId + "/ReserveNumber",
      data,
      {
        headers: {
          accept: "text/plain; ver=2.0",
          "Content-Type": "application/json; ver=2.0",
          authorization: "Bearer " + user.token,
          correlationId: correlationId,
          transactionId: transactionId,
          ...contractTypeHeader(),
        },
      }
    );
    return response.data;
  }
  else {
    return null;
  }
}



// https://test.providers.tygo.net/api/plan/437/ResellerPlanId

const getResellerPlanId = async (planId: number) => {
  const response = await Axios.get(
    REACT_APP_API_PROVIDERS + "/api/plan/" + planId + "/ResellerPlanId",
  );
  return response.data;
}


const getMetadata = async (lang: string) => {
  const user = JSON.parse(localStorage.getItem('tygo_user') || '{}');
  if (user) {
    const metadata = await Axios.get(
      // "https://test.sim.tygo.net/api/v2/Metadata",
      REACT_APP_API_SIM + "/api/v2/Metadata",
      {
        headers: {
          accept: "text/plain",
          "Accept-Language": lang,
          authorization: "Bearer " + user.token,
          ...contractTypeHeader(),
        }
      }
    );
    return metadata;
  }
  else {
    return null;
  }
}
//curl -X POST "https://test.sim.tygo.net/api/v2/Order/14/OtpConfirm" -H  "accept: text/plain; ver=2.0" -H  "Authorization: Bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNoYTI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1laWRlbnRpZmllciI6IjNhNTE0NjM1LWIzMGYtNGJjNi04YTE0LTI5ZDI5ZjU3OTBjMyIsImFwcC1pZCI6IlR5Z29XZWIiLCJjbGllbnQtaWQiOiJUeWdvQXBwIiwiU2VjdXJpdHlTdGFtcCI6IktWQU1aQ1BWT1VDNUU3TjVCNjNPUU1MNloyUFI3UDdOIiwiZmlyc3ROYW1lIjoiTm91cmVkZGRpbmUiLCJsYXN0TmFtZSI6IiIsIm5hbWUiOiJOb3VyZWRkZGluZSIsInBob25lTnVtYmVyIjoiIiwibmJmIjoiMTc0MjUwMjY0NiIsImV4cCI6IjE3NDUwOTQ2NDYiLCJpc3MiOiJodHRwczovL2xvY2FsaG9zdDo1MDAxIiwiYXVkIjoiVGF5Z29BcGkiLCJEZXZpY2VUeXBlIjoiV2ViIiwiaHR0cDovL3NjaGVtYXMubWljcm9zb2Z0LmNvbS93cy8yMDA4LzA2L2lkZW50aXR5L2NsYWltcy9yb2xlIjoiQWRtaW4ifQ.Asww7UrmqsHdmZhuE-9S0Lk_9GXJ1GZxXAkt1DnIbyk" -H  "Content-Type: application/json; ver=2.0" -d "{\"id\":\"string\",\"code\":\"string\"}"
const otpConfirm = async (data: { id: string; code: string, plan_id: number }, providerId: number) => {
  const user = JSON.parse(localStorage.getItem('tygo_user') || '{}');
  const { correlationId, transactionId } = generateCorrelationAndTransactionId(data.plan_id);

  if (user) {
    const response = await Axios.post(
      REACT_APP_API_SIM + "/api/v2/Order/" + providerId + "/OtpConfirm",
      data,
      {
        headers: {
          accept: "text/plain; ver=2.0",
          "Content-Type": "application/json; ver=2.0",
          authorization: "Bearer " + user.token,
          correlationId: correlationId,
          transactionId: transactionId,
          ...contractTypeHeader(),
        },
      }
    );
    return response.data;
  } else {
    return null;
  }
}

const CONTRACT_TYPE_KEY = 'tygo_contract_type';

// SIM MS expects the plan's contract type on every request: "1" for prepaid,
// "2" for postpaid. The plan is only in hand at the start of the local flow (and
// again once an order is loaded), while the calls that need the header run all
// the way through payment and activation — including after the payment redirect
// drops the in-memory state — so the value is persisted the same way the
// correlationId is.
const setContractType = (contractTypeId: any) => {
  const id = Number(contractTypeId);
  if (id !== 1 && id !== 2) return;
  localStorage.setItem(CONTRACT_TYPE_KEY, id.toString());
}

// Omitted rather than guessed when the contract type was never recorded.
const contractTypeHeader = () => {
  const contractType = localStorage.getItem(CONTRACT_TYPE_KEY);
  return contractType ? { "X-CONTRACT-TYPE": contractType } : {};
}

//generate a function that we will give it a plan Id and it will return a CorrelationId and TransactionId generated from this format "TYGO{DateTime.Now.ToString("MMddyyyyHHmmss")}"
//CorrelationId should not change fo the same plan Id and TransactionId should be unique for each call
const generateCorrelationAndTransactionId = (planId: number) => {
  const now = new Date();
  const dateTimeString = `${(now.getMonth() + 1).toString().padStart(2, '0')}${now.getDate().toString().padStart(2, '0')}${now.getFullYear()}${now.getHours().toString().padStart(2, '0')}${now.getMinutes().toString().padStart(2, '0')}${now.getSeconds().toString().padStart(2, '0')}`;
  
  //get correlationId from localStorage if exists for the same planId
  const correlationIdKey = `correlationId_${planId}`;
  let correlationId = localStorage.getItem(correlationIdKey);
  if (!correlationId) {
    correlationId = `TYGO${dateTimeString}`;
    localStorage.setItem(correlationIdKey, correlationId);
  }

  const transactionId = `TYGO${dateTimeString}`;

  return { correlationId, transactionId };
}

// The stored correlationId outlives the order it was created for, so it has to
// be dropped whenever a different order starts on the same plan — otherwise the
// next purchase of that plan goes out under the previous order's correlationId.
const resetCorrelationId = (planId?: number | string) => {
  localStorage.removeItem(`correlationId_${planId}`);
}

